import { render, staticRenderFns } from "./ContratosSigaPantalla.vue?vue&type=template&id=7b18f796&"
import script from "./ContratosSigaPantalla.vue?vue&type=script&lang=ts&"
export * from "./ContratosSigaPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7b18f796', component.options)
    } else {
      api.reload('7b18f796', component.options)
    }
    module.hot.accept("./ContratosSigaPantalla.vue?vue&type=template&id=7b18f796&", function () {
      api.rerender('7b18f796', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/SucursalVirtual/ContratosSiga/ContratosSigaPantalla.vue"
export default component.exports